
export type JssTreeNodeType =
    'OBJECT' |
    'LAYOUT' |
    'STRING' |
    'BOOLEAN' |
    'ENUM' |
    'INTEGER' |
    'NUMBER';

// sub type of OBJECT
export type JssTreeNodeObjectSubType =
    'OBJECT_BASE' |
    'OBJECT_FORM';

export const LOCAL_PATH_ROOT_REF_SIGN = '#';
export const LOCAL_PATH_ROOT_OBJECT = 'schema';

export type JssControlType =
    'UNDEFINED' |
    'INPUT' |
    'TEXTAREA' |
    'CHECKBOX' |
    'SELECT';

export type FormLayout =
    'Undefined' |
    'VerticalLayout' |
    'HorizontalLayout';

export type LayoutDirection =
    'ROW' |
    'COLUMN';

export interface IValidJsonSchemaObject extends IObjectInstance {
    $schema?: string;
    [key: string]: any;
}

export interface IAnyInstance<T> {
    type?: string;
    enum?: T[];
    const?: T;
    allOf?: IValidSchema[];
    anyOf?: IValidSchema[];
    oneOf?: IValidSchema[];
}

export interface IObjectInstance extends IAnyInstance<Object> {
    type: "object";
    required?: string[];
    properties?: IJsonObject;
    patternProperties?: IJsonObject;
    additionalProperties?: IValidSchema | boolean;
    maxProperties?: number; // ganze Zahl > 0
    minProperties?: number; // ganze Zahl > 0
}

export interface IStringInstance extends IAnyInstance<String> {
    type: "string";
    pattern?: string;
    format?: string;
    minLength?: number; // ganze Zahl > 0
    maxLength?: number; // ganze Zahl > 0
}

export interface INumberInstance extends IAnyInstance<Number> {
    type: "number";
    multipleOf?: number;
    maximum?: number; // ganze Zahl > 0
    minimum?: number; // ganze Zahl > 0
    exclusiveMaximum?: number; // ganze Zahl > 0
    exclusiveMinimum?: number; // ganze Zahl > 0
}

export interface IArrayInstance extends IAnyInstance<Array<any>> {
    type: "array";
    items?: IValidSchema | IValidSchema[];
    additionalItems?: IValidSchema;
    maxItems?: number; // ganze Zahl > 0
    minItems?: number; // ganze Zahl > 0
    uniqueItems?: boolean;
    contains?: IValidSchema;
}

export interface IJsonObject {
    [key: string]: IValidSchema;
}

export type IValidSchema = IObjectInstance | IStringInstance | INumberInstance | IArrayInstance;



// WEBPACK FOOTER //
// /builds/cp/frap/t3/planer/src/app/core/json-form/model/jss-types.ts